const isSignificant = (a, b) => a <= b * 0.25

export { isSignificant }
